import React, { useEffect, useMemo, useState } from "react";
import { useFieldArray, useForm, useWatch } from "react-hook-form";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";
import {
  ConstructionTypeOptions,
  landUsesTypeList,
  proposedSite,
  schemeTypeList,
  subUsesTypeList,
  tehsilData,
  yesOrNo,
} from "../../../../TCPForms/data";
import { Col, Container, Row } from "react-bootstrap";
import { Table, TableContainer } from "@mui/material";
import { IconButton } from "@mui/material";
import RemoveIcon from "@mui/icons-material/HighlightOff";
import AddIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import KmlFileUploader from "../../../../TCPForms/reusableComponents/KmlFileUploader";
import { useSelector } from "react-redux";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import { useTranslation } from "react-i18next";

const SubStep4 = ({
  formData,
  handleSubTabChange,
  handleTabChange,
  isEmployee,
  handleNoWorkflow
}) => {
  const isDA = formData?.department === "DA";
  const { t } = useTranslation();
  const [coordinate, setCoordinate] = useState([{ latitude: "", longitude: "" }]);
  const [googleLocation, setGoogleLocation] = useState("");
  const [showError, setShowError] = useState(false);
  const [maxPlotAreaSite, setMaxPlotAreaSite] = useState(formData?.descriptionOfLand?.plotAreaSite);
  const { documents } = useSelector((state) => state.formMT);
  console.log(formData, "docissue");
  
  const defaultValues = {
    ...formData,
    documents: documents,
    descriptionOfLand: {
      ...formData?.descriptionOfLand,
      googleMapCoordinates: formData?.descriptionOfLand?.googleMapCoordinates || coordinate,
      googleMapLocation: formData?.descriptionOfLand?.googleMapLocation || googleLocation,
      schemeType: formData?.descriptionOfLand?.schemeType || "",
      roadWidths: formData?.descriptionOfLand?.roadWidths || [{ value: "" }],
      approachRoadWidths: formData?.descriptionOfLand?.approachRoadWidths || [{ value: "" }],
      otherSides: formData?.descriptionOfLand?.otherSides || [{ value: "" }],
      multipleKhata: formData?.descriptionOfLand?.multipleKhata || [{ value: "" }],
      khasraDetails: formData?.descriptionOfLand?.khasraDetails || [{ district: "", tehsil: "", village: "", plotNo: "" }],
      multipleKhasra: formData?.descriptionOfLand?.multipleKhasra || [{ khasraNo: "", area: "" }],
      // khasraWithArea:formData?.
    },
  };
  const { handleSubmit, control, watch, reset, setValue } = useForm({ defaultValues });
  const handleCoordinateChange = (field, value) => {
    setCoordinate((prev) => {
      const newCoordinates = [...prev];
      newCoordinates[0] = { ...newCoordinates[0], [field]: value };
      return newCoordinates;
    });
  };

  const handleGoogleLocation = (e) => {
    setGoogleLocation(e.target.value);
  };
  const { fields: multipleKhasra, append: addKhasra, remove: removeKhasra } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhasra",
  });
  const { fields: roadWidthsArray, append: addRoadWidthField, remove: removeRoadWidthField } = useFieldArray({
    control,
    name: "descriptionOfLand.roadWidths",
  });
  const { fields: otherSides, append: addOtherSide, remove: removeOtherSide } = useFieldArray({
    control,
    name: "descriptionOfLand.otherSides",
  });
  const { fields: approachRoadWidths, append: addApproachRoad, remove: removeApproachWidth } = useFieldArray({
    control,
    name: "descriptionOfLand.approachRoadWidths",
  });
  const { fields: multipleKhata, append: addKhata, remove: removeKhata } = useFieldArray({
    control,
    name: "descriptionOfLand.multipleKhata",
  });
  const { fields: khasraDetails, append: addKhasraDetail, remove: removeKhasraDetail } = useFieldArray({
    control,
    name: "descriptionOfLand.khasraDetails",
  });

  // const [subLandUseType, setSubLandUseType] = useState({});
  // const { data: { AuthorityMasterData: { Organizations: departmentList } = {} } = {}, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(
  //   tenantId,
  //   "AuthorityMasterData",
  //   ["Organizations"]
  // );

  const watchSchemeType = watch("descriptionOfLand.schemeType");
  const khasraTehsils = useWatch({
    control,
    name: "descriptionOfLand.khasraDetails",
  });
  const filterCategoryData = (allCategories) => {};
  const isSchemeType = watchSchemeType === "Scheme";
 
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  console.log("upDIstricts", updistricts);

  const plotNo = watch("descriptionOfLand.plotNo");
 
  const plotAreaDoc = watch("descriptionOfLand.plotAreaDoc");
  const plotAreaSite = watch("descriptionOfLand.landArea");
  const validateFiles = () => {
    const uploadedDocs = new Set(documents?.map((doc) => doc.documentType)); // Using Set for faster lookups
    const requiredDocs = ["kmlFile"];

    return requiredDocs.every((doc) => uploadedDocs.has(doc)); // Use Set.has for O(1) lookup
  };
  const onSubmit = (data) => {
    const isValid = validateFiles();

    console.log("insideFormSubmit", data, isValid);
    if(isEmployee){
      const datawithdoc = {
        ...data,
        documents: formData?.documents
      }
      console.log(datawithdoc, "datawithdocgoing");
      handleNoWorkflow(datawithdoc)
    }
    if (isValid) {
      console.log("submitIf", isValid, data);
      handleTabChange(1, data);
      // onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
  };
  console.log("formDataFromLand", formData);
  useEffect(() => {
    if (formData?.descriptionOfLand?.schemeType) {
      setValue("descriptionOfLand.schemeType", formData.descriptionOfLand.schemeType);
      setValue("landInfo.owners[0].permanentAddress.district", formData?.location1);
    }

    setValue("documents", documents);

    if (formData?.location1 && khasraDetails?.length > 0) {
      khasraDetails.forEach((_, index) => {
        setValue(`descriptionOfLand.khasraDetails[${index}].district`, formData.location1);
      });
    }
  }, [formData, documents, khasraDetails]);
  useEffect(() => {
    if (plotAreaDoc && plotAreaSite) setMaxPlotAreaSite(plotAreaDoc);
  }, [plotAreaSite]);
  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Land Information")}</h2>
          </div>
          <Container className="formInputContainer common-app-form px-4" fluid>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Scheme Type"
                  inputLabel="Select Scheme Type"
                  placeholder="Select Scheme Type"
                  name="descriptionOfLand.schemeType"
                  type="searchSelect"
                  defaultValue={formData?.descriptionOfLand?.schemeType}
                  disabled
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col></Col>
            </Row>
            {isSchemeType && (
              <React.Fragment>
                <Row>
                 
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      // backgroundColor: "#f5f5f5",
                      // padding: "10px",
                      borderRadius: "5px",
                      color: "#333",
                      margin: "9px 4px",
                      fontWeight: "700",
                    }}
                  >
                    <span style={{ backgroundColor: "#f2f2f2", color: "red", padding: "4px" }}>
                      Land Use Verification is not required in case of Scheme. Please fill Land Information details for Map submission.
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Type of Scheme"
                      placeholder="Select type of scheme"
                      name={`descriptionOfLand.planOn`}
                      type="searchSelect"
                      maxLength={30}
                      defaultValue={formData?.descriptionOfLand?.planOn}
                      mandatory
                      disabled
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>

                  <Col>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Name of Scheme"
                      placeholder="Select Name of Scheme"
                      name={`descriptionOfLand.schemeName`}
                      type="searchSelect"
                      maxLength={30}
                      defaultValue={formData?.descriptionOfLand?.schemeName}
                      mandatory
                      disabled
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              </React.Fragment>
            )}
            <Row>
              <React.Fragment>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label={isSchemeType ? "Land Use as per Layout Plan" : "Land Use as per Master Plan"}
                    inputLabel="Select a plan."
                    placeholder={isSchemeType ? "Select Land Use as per Layout Plan" : "Select Land Use as per Master Plan"}
                    name="descriptionOfLand.landUsesType"
                    type="searchSelect"
                    mandatory={true}
                    isRequired={true}
                    disabled
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.descriptionOfLand?.landUsesType}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label={isSchemeType ? "Land Sub Use as per Layout Plan" : "Land Sub Use as per Master Plan"}
                    control={control}
                    placeholder={isSchemeType ? "Select Land Sub Use as per Layout Plan" : "Select Land Sub Use as per Master Plan"}
                    name="descriptionOfLand.subLandUseAsPerLayout"
                    type="searchSelect"
                    disabled
                    mandatory
                    maxLength={150}
                    multiLine
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.descriptionOfLand?.subLandUseAsPerLayout}
                  />
                </Col>
              </React.Fragment>
              {/* )} */}
            </Row>
            {/* {isSchemeType && ( */}
            {/* (formData?.descriptionOfLand?.landUsesType === "Scheme" && formData?.descriptionOfLand?.landUsesType)) && ( */}

            <Row>
              <React.Fragment>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    label={t("Primary Use of Proposed Activity")}
                    placeholder={t("Select Primary Use of Proposed Activity")}
                    name="descriptionOfLand.activityAsPerMap"
                    defaultValue={formData?.descriptionOfLand?.activityAsPerMap}
                    type="searchSelect"
                    mandatory
                    disabled
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label={t("Activity Proposed")}
                    control={control}
                    placeholder={t("Select Activity Proposed")}
                    name="descriptionOfLand.activityProposed"
                    type="searchSelect"
                    mandatory
                    disabled
                    maxLength={20}
                    multiLine
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    defaultValue={formData?.descriptionOfLand?.activityProposed}
                  />
                </Col>
              </React.Fragment>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label={t("Development Area")}
                  control={control}
                  placeholder={t("Select Development Area")}
                  data={SortingAlphabatically(ConstructionTypeOptions)}
                  name="descriptionOfLand.developmentArea"
                  mandatory
                  disabled
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  defaultValue={formData?.descriptionOfLand?.constructionType}
                  type="searchSelect"
                />
              </Col>
              <Col></Col>
              {/* {!isSchemeType ? (
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label={t("Does your land fall under more than one village?")}
                    control={control}
                    placeholder={t("Select yes/no")}
                    data={SortingAlphabatically(yesOrNo)}
                    name="descriptionOfLand.multipleVillages"
                    mandatory
                    disabled={isEmployee || }
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    isRequired={true}
                    defaultValue={formData?.descriptionOfLand?.multipleVillages}
                    type="radioButton"
                  />
                </Col>
              ) : (
                <Col></Col>
              )} */}
            </Row>
            {/* <Row>
              {(!isSchemeType || formData?.descriptionOfLand?.selectLandUse) && (
                <Col>
                  <InputWrapper
                    control={control}
                    label="Permissibility of Activities"
                    inputLabel="Select activities."
                    placeholder="Select activities."
                    name="descriptionOfLand.selectLandUse"
                    type="searchSelect"
                    disabled={isEmployee || }
                    // defaultValue={formData?.descriptionOfLand?.selectLandUse}
                    data={SortingAlphabatically(landUseListActivities)}
                  />
                </Col>
              )}
              {(!isSchemeType || formData?.descriptionOfLand?.proposedActivity) && (
                <Col>
                  <InputWrapper
                    control={control}
                    label="Proposed Activity as per Zoning Regulation"
                    placeholder="Enter activity"
                    name={`descriptionOfLand.proposedActivity`}
                    type="textInput"
                    maxLength={30}
                    disabled={isEmployee || }
                    height="40px"
                  />
                </Col>
              )}
            </Row> */}
            {!isSchemeType ? (
              <fieldset className="fieldset-wrapper bg-white">
                {/* <legend style={{ fontWeight: "bold", fontSize: "1rem" }}>Land/Khasra Details</legend> */}
                <TableContainer className="table-container">
                  <Table stickyHeader className="application-table landUserTable" border="1" cellPadding="8">
                    <thead className="table-no-background" style={{ 
                      background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
                      // background: "#f0f0f0" 
                      }}>
                      <tr>
                        <th style={{ width: "25%" }}>
                          {t("LABEL_DISTRICT")}
                          <span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "20%" }}>
                          {t("Tehsil")}
                          <span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "20%" }}>
                          Village<span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "25%" }}>
                          Plot No./Khasra No./Arazi No.<span className="compulsoryField"> *</span>
                        </th>
                        <th style={{ width: "10%" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {khasraDetails.map((item, index) => {
                        const selectedTehsil = khasraTehsils?.[index]?.tehsil;                        
                        return (
                          <tr key={item.id}>
                            <td>
                              <InputWrapper
                                width={"100%"}
                                // label=""
                                hasLabel={false}
                                control={control}
                                data={SortingAlphabatically(updistricts)}
                                placeholder="Select District"
                                name={`descriptionOfLand.khasraDetails[${index}].district`}
                                type="textInput"
                                defaultValue={formData?.location1}
                                disabled
                                mandatory
                                isRequired
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td>
                              <InputWrapper
                                width={"100%"}
                                // label=""
                                hasLabel={false}
                                control={control}
                                placeholder="Select Tehsil"
                                name={`descriptionOfLand.khasraDetails[${index}].tehsil`}
                                defaultValue={formData?.descriptionOfLand?.khasraDetails?.[index]?.tehsil}
                                type="searchSelect"
                                disabled
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td>
                              <InputWrapper
                                width={"100%"}
                                // label=""
                                hasLabel={false}
                                control={control}
                                placeholder="Select Village"
                                name={`descriptionOfLand.khasraDetails[${index}].village`}
                                defaultValue={formData?.descriptionOfLand?.khasraDetails?.[index]?.village}
                                type="searchSelect"
                                maxLength={30}
                                disabled
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td>
                              <InputWrapper
                                // label=""
                                width={"100%"}
                                hasLabel={false}
                                control={control}
                                placeholder="Enter Plot No./Khasra No./Arazi No."
                                mandatory
                                name={`descriptionOfLand.khasraDetails[${index}].plotNo`}
                                type="specialChar"
                                allowedChars="/,-"
                                maxLength={200}
                                disabled
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {index > 0 && (
                                <IconButton onClick={() => removeKhasraDetail(index)} disabled>
                                  <RemoveIcon />
                                </IconButton>
                              )}
                              {index === khasraDetails.length - 1 && (
                                <IconButton
                                  onClick={() => addKhasraDetail({ plotNo: "", district: "", tehsil: "", village: "" })}
                                  disabled
                                >
                                  <AddIcon />
                                </IconButton>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </TableContainer>
              </fieldset>
            ) : (
              <Row>
                <Col>
                  <InputWrapper
                    width={"100%"}
                    label="Plot No."
                    control={control}
                    placeholder="Enter Plot No."
                    mandatory={true}
                    name="descriptionOfLand.plotNo"
                    type="specialChar"
                    allowedChars="/,-"
                    maxLength={200}
                    disabled
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>

                <Col>
                  <InputWrapper
                    width={"100%"}
                    control={control}
                    data={SortingAlphabatically(updistricts)}
                    label={t("LABEL_DISTRICT")}
                    placeholder="Select District"
                    name="landInfo.owners[0].permanentAddress.district"
                    type="searchSelect"
                    defaultValue={formData?.location1}
                    disabled
                    mandatory
                    isRequired={true}
                    validation={{
                      required: {
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Plot area (as per document) (sq. m)"
                  placeholder="Enter Plot area (as per document) (sq. m)"
                  // defaultValue={formData?.descriptionOfLand?.landArea}
                  // value={totalPlotAreaVal}
                  name="descriptionOfLand.plotAreaDoc"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  validation={{
                    required: {
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={6}
                  disabled
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  control={control}
                  label="Plot area (as per site) (sq. m)"
                  placeholder="Enter Plot area (as per site) (sq. m)"
                  // defaultValue={formData?.descriptionOfLand?.landArea}
                  // value={totalPlotAreaVal}
                  name="descriptionOfLand.landArea"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  message="The value must not exceed plot area as per document"
                  maxValue={maxPlotAreaSite}
                  disabled
                  validation={{
                    required: {
                      message: "This field is required",
                    },
                  }}
                  isRequired={true}
                  maxLength={6}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {roadWidthsArray.map((field, index) => (
                  <div style={{ display: "flex", position: "relative" }}>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label="Road width (existing) (m)"
                      placeholder="Enter Road width (existing) (m)"
                      // defaultValue={field.value}
                      name={`descriptionOfLand.roadWidths.${index}.value`}
                      type="specialChar"
                      allowedChars="."
                      onlyNumeric={true}
                      mandatory
                      disabled
                      containerStyles={{ width: "100%" }}
                      isRequired={true}
                      maxLength={5}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                    {!isEmployee && (
                      <div className="adornment" style={{ position: "absolute", right: "0px" }}>
                        {index === roadWidthsArray.length - 1 && roadWidthsArray.length < 4 && (
                          <IconButton
                            sx={{ color: "#000" }}
                            aria-label="Add more"
                            disabled={roadWidthsArray.length >= 4}
                            onClick={() => addRoadWidthField({ value: "" })}
                          >
                            <AddIcon sx={{ color: "#000" }} />
                          </IconButton>
                        )}
                        {roadWidthsArray.length > 1 && index > 0 && (
                          <IconButton color="error" aria-label="Delete" onClick={() => removeRoadWidthField(index)}>
                            <RemoveIcon />
                          </IconButton>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </Col>
              <Col>
                {approachRoadWidths.map((field, index) => (
                  <div style={{ display: "flex", position: "relative" }}>
                    <InputWrapper
                      width={"100%"}
                      control={control}
                      label={isSchemeType ? "Road width (as per layout plan) (m)" : "Road width (as per master plan)(m)"}
                      placeholder={isSchemeType ? "Enter Road width (as per layout plan) (m)" : "Enter Road width (as per master plan)(m)"}
                      // defaultValue={field.value}
                      name={`descriptionOfLand.approachRoadWidths.${index}.value`}
                      type="specialChar"
                      allowedChars="."
                      onlyNumeric={true}
                      mandatory
                      containerStyles={{ width: "100%" }}
                      isRequired={true}
                      maxLength={5}
                      sx={{ Padding: "0px" }}
                      disabled
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                    {!isEmployee && (
                      <div className="adornment" style={{ position: "absolute", right: "0px" }}>
                        {index === approachRoadWidths.length - 1 && approachRoadWidths.length < 4 && (
                          <IconButton
                            sx={{ color: "#000" }}
                            aria-label="Add more"
                            disabled={approachRoadWidths.length >= 4}
                            onClick={() => addApproachRoad({ value: "" })}
                          >
                            <AddIcon sx={{ color: "#000" }} />
                          </IconButton>
                        )}
                        {approachRoadWidths.length > 1 && index > 0 && (
                          <IconButton color="error" aria-label="Delete" onClick={() => removeApproachWidth(index)}>
                            <RemoveIcon />
                          </IconButton>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </Col>
            </Row>
            <Row>
              <Col onChange={(e) => handleCoordinateChange("latitude", e.target.value)}>
                <InputWrapper
                  width={"100%"}
                  label="Latitude"
                  control={control}
                  placeholder="Enter Latitude"
                  name="descriptionOfLand.latitude"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  disabled
                  isRequired={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Coordinates"),
                      message: "Value cannot be zero. Please provide valid coordinate.",
                    },
                  }}
                  minLength={8}
                  maxLength={10}
                />
              </Col>
              <Col onChange={(e) => handleCoordinateChange("longitude", e.target.value)}>
                <InputWrapper
                  width={"100%"}
                  label="Longitude"
                  control={control}
                  placeholder="Enter Longitude"
                  name="descriptionOfLand.longitude"
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  disabled
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("Coordinates"),
                      message: "Value cannot be zero. Please provide valid coordinate.",
                    },
                  }}
                  isRequired={true}
                  maxLength={10}
                  minLength={8}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Land Address"
                  control={control}
                  placeholder="Enter Land Address"
                  defaultValue={formData?.descriptionOfLand?.landAddress}
                  name="descriptionOfLand.landAddress"
                  type="specialChar"
                  allowedChars="_&:,/. -"
                  mandatory
                  disabled
                  maxLength={30000}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  width={"100%"}
                  label="Nearby Landmark"
                  control={control}
                  placeholder="Enter Nearby Landmark"
                  defaultValue={formData?.descriptionOfLand?.landMark}
                  name="descriptionOfLand.landMark"
                  type="specialChar"
                  allowedChars="_&:,/. -"
                  mandatory
                  required
                  disabled
                  maxLength={25}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
             <Row>
                  <Col>
                    
                    <InputWrapper
                    width={"100%"}
                      control={control}
                      label={t("Ground Coverage")}
                      placeholder={t("Enter Ground Coverage")}
                      name="descriptionOfLand.proposedGoundCoverageSqM"
                      defaultValue={formData?.descriptionOfLand?.proposedGoundCoverageSqM}
                      type="textInput"
                      mandatory={isEmployee}
                      disabled={!isEmployee}
                      validation={{
                        required: {
                          value: isEmployee,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>

                  <Col>
                   
                    <InputWrapper
                      control={control}
                      width={"100%"}
                      label={t("FAR")}
                      placeholder={t("Enter FAR")}
                       disabled={!isEmployee}
                      name="descriptionOfLand.maximumCoverage"
                      defaultValue={formData?.descriptionOfLand?.maximumCoverage}
                      type="textInput"
                      mandatory={isEmployee}
                      validation={{
                        required: {
                          value: isEmployee,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>
                </Row>

                   <Row>
                  <Col>
                    <InputWrapper
                      label={t("Front")}
                      width={"100%"}
                      control={control}
                      placeholder={t("Enter Front")}
                      name="descriptionOfLand.plotFront"
                       disabled={!isEmployee}
                      mandatory={isEmployee}
                      maxLength={2}
                      defaultValue={formData?.descriptionOfLand?.plotFront}
                      type="textInput"
                      validation={{
                        required: {
                          value: isEmployee,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                  <Col>
                   
                    <InputWrapper
                    width={"100%"}
                      label={t("Rear")}
                      control={control}
                      placeholder={t("Enter Rear")}
                      name="descriptionOfLand.plotRear"
                       disabled={!isEmployee}
                      mandatory={isEmployee}
                      maxLength={2}
                      defaultValue={formData?.descriptionOfLand?.plotRear}
                      type="textInput"
                      validation={{
                        required: {
                          value: isEmployee,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>

                 <Row>
                  <Col>
                    <InputWrapper
                    width={"100%"}
                      label={t("Side Setback-1")}
                      control={control}
                      placeholder={t("Enter Side Setback-1")}
                      name="descriptionOfLand.plotSide1"
                       disabled={!isEmployee}
                      mandatory={isEmployee}
                      maxLength={2}
                      defaultValue={formData?.descriptionOfLand?.plotSide1}
                      type="textInput"
                      validation={{
                        required: {
                          value: isEmployee,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                  <Col>
                   
                    <InputWrapper
                    width={"100%"}
                      label={t("Side Setback-2")}
                      control={control}
                      placeholder={t("Enter Side Setback-2")}
                      name="descriptionOfLand.plotSide2"
                      mandatory={isEmployee}
                      maxLength={2}
                       disabled={!isEmployee}
                      defaultValue={formData?.descriptionOfLand?.plotSide2}
                      type="textInput"
                      validation={{
                        required: {
                          value: isEmployee,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
            <Row>
              <Col>
                   
                    <InputWrapper
                    width={"100%"}
                      control={control}
                      label={t("Permissible Height")}
                      placeholder={t("Enter Building Height")}
                      name="descriptionOfLand.landLength"
                      defaultValue={formData?.descriptionOfLand?.landLength}
                      type="textInput"
                       disabled={!isEmployee}
                      mandatory={isEmployee}
                      validation={{
                        required: {
                          value: isEmployee,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>
                  <Col></Col>
            </Row>

            <Row>
              <Col>
                <div className="custom-upload new-custom-uploader">
                  {!isEmployee && (
                    <KmlFileUploader
                      name={"kmlFile"}
                      label={"KML File"}
                      isMandatory
                      validationMsg={"(.kml file only and Max file Size 10 MB)"}
                      required
                      tab={1}
                      showError={showError}
                      // control={control}
                      maxFiles={1}
                    />
                  )}
                </div>
              </Col>
              <Col></Col>
            </Row>
          </Container>
          <div className="footerContainer2">
            
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                  onClick={() => handleSubTabChange(2)}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#000", marginRight: "4px" }}
                />
              </div>
          </div>
        </div>
      </form>
    </section>
  );
};

export default SubStep4;
